<template>
    <q-dialog ref="dialogRef" @hide="onDialogHide">
        <q-card class="q-dialog-plugin">
            <q-form @submit.prevent="copy">
                <q-card-section>
                    <div class="text-h6">Копировать выбранные задачи в</div>
                    <q-select use-input v-model="selectedProject" emit-value map-options :option-label="projectLabel"
                        @filter="projectFilter" option-value="id" :options="projectOptions" :loading="isProjectLoading"
                        label="Проект" />
                </q-card-section>
                <q-card-section v-if="selectedProject">
                    <q-select v-model="taskType" clearable :loading="isTaskTypeLoading" :options="taskTypes"
                        option-label="name" option-value="id" label="Тип" emit-value behavior="menu" map-options />
                    <q-select use-chips multiple v-model="taskLabels" clearable :loading="isLabelLoading" :options="labels"
                        option-label="name" option-value="id" label="Ярлыки" emit-value behavior="menu" map-options>
                        <template v-slot:no-option>
                            <q-item>
                                <q-item-section class="text-italic text-grey">
                                    Нет доступных ярлыков
                                </q-item-section>
                            </q-item>
                        </template>
                    </q-select>
                    <q-select use-chips multiple v-model="performers" clearable :loading="isUserLoading"
                        :options="performerUsers" :option-label="(user) => `${user.username} (${user.email})`"
                        option-value="email" label="Исполнители" emit-value behavior="menu" map-options />
                    <q-input v-model="startTime" label="Дата начала">
                        <template v-slot:prepend>
                            <q-icon name="event" class="cursor-pointer">
                                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                    <q-date v-model="startTime" mask="YYYY-MM-DD HH:mm">
                                        <div class="row items-center justify-end">
                                            <q-btn v-close-popup label="Закрыть" color="primary" flat />
                                        </div>
                                    </q-date>
                                </q-popup-proxy>
                            </q-icon>
                        </template>

                        <template v-slot:append>
                            <q-icon name="access_time" class="cursor-pointer">
                                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                    <q-time v-model="startTime" mask="YYYY-MM-DD HH:mm" format24h>
                                        <div class="row items-center justify-end">
                                            <q-btn v-close-popup label="Закрыть" color="primary" flat />
                                        </div>
                                    </q-time>
                                </q-popup-proxy>
                            </q-icon>
                        </template>
                    </q-input>
                    <q-input v-model="executionTime" label="Дата выполнения">
                        <template v-slot:prepend>
                            <q-icon name="event" class="cursor-pointer">
                                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                    <q-date v-model="executionTime" mask="YYYY-MM-DD HH:mm">
                                        <div class="row items-center justify-end">
                                            <q-btn v-close-popup label="Закрыть" color="primary" flat />
                                        </div>
                                    </q-date>
                                </q-popup-proxy>
                            </q-icon>
                        </template>

                        <template v-slot:append>
                            <q-icon name="access_time" class="cursor-pointer">
                                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                    <q-time v-model="executionTime" mask="YYYY-MM-DD HH:mm" format24h>
                                        <div class="row items-center justify-end">
                                            <q-btn v-close-popup label="Закрыть" color="primary" flat />
                                        </div>
                                    </q-time>
                                </q-popup-proxy>
                            </q-icon>
                        </template>
                    </q-input>
                </q-card-section>
                <q-card-section class="col-6" v-if="selectedType?.propertyDescription.length > 0">
                    <div class="text-subtitle2">Дополнительные параметры</div>
                    <template v-for="property in properties">
                        <template v-if="property.type === 'STRING'">
                            <q-input v-model="property.value" :label="property.name" :rules="[requiredRule]" />
                        </template>
                        <template v-if="property.type === 'NUMBER'">
                            <q-input v-model.number="property.value" :label="property.name" type="number"
                                :rules="[requiredRule]" />
                        </template>
                        <template v-if="property.type === 'DATE'">
                            <q-input v-model="property.value" :label="property.name" :rules="[requiredRule]">
                                <template v-slot:prepend>
                                    <q-icon name="event" class="cursor-pointer">
                                        <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                            <q-date v-model="property.value" mask="YYYY-MM-DD">
                                                <div class="row items-center justify-end">
                                                    <q-btn v-close-popup label="Закрыть" color="primary" flat />
                                                </div>
                                            </q-date>
                                        </q-popup-proxy>
                                    </q-icon>
                                </template>
                            </q-input>
                        </template>
                        <template v-if="property.type === 'DATETIME'">
                            <q-input v-model="property.value" :label="property.name" :rules="[requiredRule]">
                                <template v-slot:prepend>
                                    <q-icon name="event" class="cursor-pointer">
                                        <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                            <q-date v-model="property.value" mask="YYYY-MM-DD HH:mm">
                                                <div class="row items-center justify-end">
                                                    <q-btn v-close-popup label="Закрыть" color="primary" flat />
                                                </div>
                                            </q-date>
                                        </q-popup-proxy>
                                    </q-icon>
                                </template>

                                <template v-slot:append>
                                    <q-icon name="access_time" class="cursor-pointer">
                                        <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                            <q-time v-model="property.value" mask="YYYY-MM-DD HH:mm" format24h>
                                                <div class="row items-center justify-end">
                                                    <q-btn v-close-popup label="Закрыть" color="primary" flat />
                                                </div>
                                            </q-time>
                                        </q-popup-proxy>
                                    </q-icon>
                                </template>
                            </q-input>
                        </template>
                    </template>
                </q-card-section>
                <!--
              ...content
              ... use q-card-section for it?
            -->

                <!-- buttons example -->
                <q-card-section v-if="copied">
                    <q-linear-progress :value="copyTasks / tasks.length" class="q-mt-md" />

                </q-card-section>
                <q-card-actions align="right">
                    <q-btn :disable="!selectedProject" :loading="copied" no-caps label="Скопировать" type="submit"
                        color="primary" />
                    <q-btn :disable="copied" color="primary" label="Отмена" no-caps @click="onDialogCancel" />
                </q-card-actions>
            </q-form>

        </q-card>
    </q-dialog>
</template>
<script setup lang="ts">
import { useDialogPluginComponent } from 'quasar'
import { useProjectLabels, useProjectUsers, useSelectProjects } from '../composables/project'
import { useAddTask, useAddTaskLabels, useAddTaskPerformers, useCopyTasks, useTask, useTaskTypes } from '../composables/task'
import { computed, ref, toRefs, watch } from 'vue'
import { requiredRule, notEmptyRule } from "../util/rules";
import { NewTask } from '../models/task';
import { useDayJs } from '../composables/dayjs';
import { useRouteParams } from '@vueuse/router';
import { useRouter } from 'vue-router';
import { Project } from '../models/project';
const dayjs = useDayJs()
const projectId = useRouteParams('projectId', undefined, { transform: Number })

const props = withDefaults(defineProps<{
    tasks: number[]
}>(), { tasks: [] })

const { tasks } = toRefs(props)
defineEmits([
    // REQUIRED; need to specify some events that your
    // component will emit through useDialogPluginComponent()
    ...useDialogPluginComponent.emits
])

const selectedProject = ref<number | null>(null)
const { data: projects, isFetching: isProjectLoading } = useSelectProjects()
const projectOptions = ref<Project[]>([])
watch(projects, (val) => {
    if (val) {
        projectOptions.value = val
    }
})

function projectFilter(value: string, update) {
    if (value) {
        update(() => {
            projectOptions.value = projects.value?.filter(project => projectLabel(project).includes(value)) ?? []
        })
    } else {
        update(() => {
            projectOptions.value = projects.value ?? []
        })
    }
}

function projectLabel(project: Project) {
    return project.name + (project.type?.name ? ` (${project.type?.name})` : '')
}

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
const { data: labels, isFetching: isLabelLoading } = useProjectLabels(selectedProject)
const { data: users, isFetching: isUserLoading } = useProjectUsers(selectedProject)
const { data: taskTypes, isFetching: isTaskTypeLoading } = useTaskTypes(selectedProject)

const performerUsers = computed(() => users.value?.filter(u => u.permission !== "READ").map(u => u.user) ?? [])
const selectedType = computed(() => !!taskType.value ? taskTypes.value?.find(t => t.id === taskType.value) : null)
const taskLabels = ref<number[]>([])
const performers = ref<string[]>([])
const executionTime = ref(null)
const taskType = ref(null)
const copyTasks = ref(0)
const copied = ref(false)
const startTime = ref(null)

const router = useRouter()
const properties = ref([])
watch(selectedType, val => {
    properties.value = val?.propertyDescription.map(d => ({
        ...d,
        value: null
    })) ?? []
})

async function copy() {
    copied.value = true
    const selectedProjectId = selectedProject.value
    if (!selectedProjectId) {
        return
    }
    await useCopyTasks(projectId, tasks, selectedProjectId, {
        typeId: taskType.value,
        properties: properties.value,
        startTime: startTime.value ? dayjs(startTime.value).utc().format() : null,
        executionTime: executionTime.value ? dayjs(executionTime.value).utc().format() : null,
        assigned: performers.value,
        labels: taskLabels.value
    })
    copied.value = false
    onDialogOK()
}
</script>